import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp2000',
    ecrans: ['00-2'],
    params: ['id']
});
